<mat-carousel *ngIf="images?.length; else noImage"
  timings="200ms ease-in"
  [autoplay]="autoplay"
  interval="6000"
  color="accent"
  proportion="100"
  [slides]="images?.length"
  [loop]="true"
  [hideArrows]="false"
  [hideIndicators]="false"
  [useKeyboard]="true"
  [useMouseWheel]="false"
  orientation="ltr">
  <mat-carousel-slide
    *ngFor="let image of images; let i = index"
    [image]="image.url"
    overlayColor="#00000000"
    [hideOverlay]="false">
  </mat-carousel-slide>
</mat-carousel>
<ng-template #noImage>
  <img src="assets/images/no-photo.svg"/>
</ng-template>
